import { CompRef, DocumentServicesObject } from '@wix/document-services-types';
import {
  EditorPointer,
  EditorPointerServiceAPI,
} from '@wix/editor-platform-feature-store';
import {
  createEditorPlatformBuilderServicesError,
  EditorPlatformBuilderServicesErrorCode,
} from '../errors';

const getComponentAppData = (
  editorPointer: EditorPointer<CompRef>,
  documentServicesAPI: DocumentServicesObject,
  editorPointerAPI: EditorPointerServiceAPI,
): {
  appDefinitionId: string;
  componentId: string;
  compType: string;
} => {
  const compRef = editorPointerAPI.getDocumentPointer(editorPointer);
  const compType = documentServicesAPI.components.getType(compRef);

  const builderCompData =
    documentServicesAPI.builder.components.getCompAppData(compType);
  const nonBuilderCompData = documentServicesAPI.components.data.get(compRef);

  const appDefinitionId =
    builderCompData?.appDefinitionId || nonBuilderCompData?.appDefinitionId;
  const componentId =
    builderCompData?.componentId || nonBuilderCompData?.widgetId;

  if (!appDefinitionId || !componentId) {
    throw createEditorPlatformBuilderServicesError(
      EditorPlatformBuilderServicesErrorCode.NotValidComponent,
      'Component does not belong to an app',
    ).withComponentType(compType);
  }

  return {
    appDefinitionId,
    componentId,
    compType,
  };
};

function getAppData(
  editorPointer: EditorPointer<CompRef>,
  documentServicesAPI: DocumentServicesObject,
  editorPointerAPI: EditorPointerServiceAPI,
) {
  const { appDefinitionId } = getComponentAppData(
    editorPointer,
    documentServicesAPI,
    editorPointerAPI,
  );

  return documentServicesAPI.platform.getAppDataByAppDefId(appDefinitionId);
}

function getCompTypeFromEditorPointer(
  editorPointer: EditorPointer<CompRef>,
  editorPointerAPI: EditorPointerServiceAPI,
  documentServicesAPI: DocumentServicesObject,
) {
  const compRef = editorPointerAPI.getDocumentPointer(editorPointer);
  return documentServicesAPI.components.getType(compRef);
}

export { getComponentAppData, getAppData, getCompTypeFromEditorPointer };
